import React, {useState, useCallback, useEffect} from 'react';
import { BrowserRouter as Router, Switch, Route, Redirect } from 'react-router-dom';
import { useRouter } from 'components';
import { StoreProvider } from 'store';
import { ViewPage } from './cms/pages/viewPage/viewPage';
import { EditPage } from './cms/pages/editPage/editPage';
import { TopHeader } from './layout/topHeader/topHeader';
//import { Footer } from './layout/footer/footer';
import { BottomDock } from './layout/bottomDock/bottomDock';
// import { BlogView } from './site/blog/blogView';
import { useScrollPosition } from '@n8tb1t/use-scroll-position';
import { useParallax } from 'components';
import { AppVersionPage } from 'components';
import { MediaQueryStatus } from 'components';
import { CommonVideoPopup } from "./layout/popup/commonVideoPopup";
import { HelmetProvider } from 'react-helmet-async';
import { AtdwPage, AtdwContext } from 'site/atdw/index';
import AOS from 'aos';

function PageUpdated() {
  //const { pathname } = useRouter();
  const { path } = useRouter();
  const parallax = useParallax();

  React.useLayoutEffect(() => {
    window.scrollTo(0, 0);
    parallax.reset();
    // eslint-disable-next-line
  }, [path]);
  return null;
}

function AppLayout(props) {
  const { pathname } = useRouter();
  const [themeColor, setThemeColor] = useState('');
  //const [scrolled, setScrolled] = useState(false)
  //const path = usePath();
  //const routeResult = useRoutes(routes);

  // const parallax = useParallax();
  // //console.log(path, routeResult);
  // const routeChanged = (path) => {
  //   //console.log(path);
  //   parallax.reset();
  // }

  useScrollPosition(({ prevPos, currPos }) => {
    //console.log(currPos.x)
    //console.log(currPos.y);
    if (currPos.y > 90) {
      document.querySelector('body').classList.add('scrolled')
    } else {
      document.querySelector('body').classList.remove('scrolled')
    }
    //setScrolled(currPos.y > 90)
  }, [], null, true)

  //const pageChanged = useCallback(path => routeChanged(path), [])
  //useLocationChange((path) => { routeChanged(path, history)})
  //useLocationChange(path => routeChanged(path))

  //sapmple
  // const onChangeThemeColor = ((value) => {
  //   console.log("onChangeThemeColor");
  //   setThemeColor(value);
  // });

  const onChangeThemeColor = useCallback((value)=>{
    //console.log("onChangeThemeColor");
    setThemeColor(value);
  }, []);

  useEffect(()=>{
    AOS.init({
      duration : 1200
    });
  }, []);

  return (
    <div className={`body-content ${pathname === '/' ? 'homepage' : 'subpage'} ${themeColor}`}>
      <PageUpdated />
      <TopHeader ></TopHeader>
      <div className="main-content">
        <div className="app-content">
          <Switch>
            <Route path="/ver" children={<AppVersionPage />} />
            <Route path="/cms/page/render/:id" children={<EditPage onChangeThemeColor = {onChangeThemeColor} />} />
            <Route path="/admin">
              <Redirect to="/admin" />
            </Route>
            <Route path="/atdwproduct/:slug" children = {<AtdwPage onChangeThemeColor = {onChangeThemeColor} />}/>
            <Route path="/">
              <ViewPage onChangeThemeColor = {onChangeThemeColor} />
            </Route>
          </Switch>
        </div>
        {/* <app-common-bottom-partial></app-common-bottom-partial> */}
      </div>
      {/* <Footer></Footer> */}
      <div style = {{ marginBottom : '2rem'}}></div>
      <BottomDock></BottomDock>
      <MediaQueryStatus />
      <CommonVideoPopup />
    </div>
  );
}

function App() {
  
  const [atdwDataHistory, setAtdwDataHistory] = useState(null);
  const [atdwDataHistory2, setAtdwDataHistory2] = useState(null);

  function setupAtdwDataHistory(value){
    //console.log("setupAtdwDataHistory", value);
    setAtdwDataHistory(value);
  }

  function setupAtdwDataHistory2(value){
    //console.log("setupAtdwDataHistory2");
    setAtdwDataHistory2(value);
  }

  return (
    <StoreProvider>
      <HelmetProvider>
      <Router>
        <AtdwContext.Provider value={{atdwDataHistory, atdwDataHistory2, setupAtdwDataHistory, setupAtdwDataHistory2}}>
          <AppLayout /> 
        </AtdwContext.Provider>
      </Router>
      </HelmetProvider>
    </StoreProvider>
  );
}
export default App;

//<AtdwContext.Provider value={{atdwDataHistory, atdwDataHistory2, setupAtdwDataHistory, setupAtdwDataHistory2}}>
//<AppLayout />
//</AtdwContext.Provider>